import React from "react";
import { EuiEmptyPrompt, EuiOverlayMask } from "@elastic/eui";

import ScaleLoader from "react-spinners/ScaleLoader";
import { hackColors } from "../../common/sense";
import { useSelector } from "react-redux";
import { selectLoadings } from "./global_loading.slice";

export const GlobalLoading = () => {
  const datas = useSelector(selectLoadings);

  const loaderInfo = datas.length > 0 ? datas[datas.length - 1] : null;

  if (!loaderInfo) {
    return <></>;
  }
  return (
    <div className="relative-full-m-full">
      <EuiOverlayMask>
        <EuiEmptyPrompt
          className="absolute-center"
          title={
            <ScaleLoader
              color={hackColors.blue}
              loading={true}
              height={35}
              width={4}
              radius={2}
              margin={2}
            />
          }
          body={<h4 className="mt-1">{loaderInfo.message}</h4>}
        />
      </EuiOverlayMask>
    </div>
  );
};
